// extracted by mini-css-extract-plugin
export default {"header":"MontpellierIAConnect_header__FZYCa","contentContainer":"MontpellierIAConnect_contentContainer__Rkj9y"};